import { render, staticRenderFns } from "./SlotPricingEditor.vue?vue&type=template&id=3e65c510&scoped=true"
import script from "./SlotPricingEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./SlotPricingEditor.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SlotPricingEditor.vue?vue&type=style&index=0&id=3e65c510&prod&lang=scss&scoped=true"
import style1 from "./SlotPricingEditor.vue?vue&type=style&index=1&id=3e65c510&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e65c510",
  null
  
)

export default component.exports